import type { GameEvent } from "../../engine/types";

export const MAMMAL_EVENTS: readonly GameEvent[] = [
  {
    id: "m_first_breath",
    opening: true,
    archetypes: ["MAMMAL"],
    stages: ["newborn"],
    once: true,
    weight: 20,
    text: "โลกภายนอกทั้งสว่างและหนาว กลิ่นอุ่นๆ ของแม่อยู่ใกล้แค่เอื้อม",
    choices: [
      { label: "ซุกตัวเข้าหาแม่", outcomes: [{ chance: 1, text: "ไออุ่นจากตัวแม่ทำให้คุณหลับสบาย", effects: { health: 5, safety: 10 } }] },
      { label: "ร้องเรียกเสียงดัง", outcomes: [{ chance: 1, text: "แม่หันมาเลียตัวคุณจนสะอาด", effects: { fullness: 10 } }] },
    ],
  },
  {
    id: "m_nursing",
    archetypes: ["MAMMAL"],
    stages: ["newborn", "nursing"],
    weight: 9,
    text: "ถึงเวลากินนมแม่แล้ว",
    choices: [
      { label: "กินให้เต็มที่", outcomes: [{ chance: 1, text: "นมอุ่นๆ ทำให้ท้องอิ่ม", effects: { fullness: 35 } }] },
      {
        label: "แย่งกับพี่น้อง",
        outcomes: [
          { chance: 0.6, text: "คุณได้ที่ดีที่สุด กินจนพุงกาง", effects: { fullness: 45 } },
          { chance: 0.4, text: "พี่น้องตัวใหญ่กว่าผลักคุณออกไป", effects: { fullness: 10, health: -5 } },
        ],
      },
    ],
  },
  {
    id: "m_mother_away",
    archetypes: ["MAMMAL"],
    stages: ["newborn", "nursing"],
    weight: 4,
    text: "แม่ออกไปหาอาหาร ทิ้งคุณไว้ในที่ซ่อน",
    choices: [
      {
        label: "อยู่นิ่งๆ ในที่ซ่อน",
        outcomes: [
          { chance: 0.85, text: "แม่กลับมาพร้อมท้องที่อิ่ม คุณปลอดภัยดี", effects: { safety: 5 } },
          { chance: 0.15, text: "มีสัตว์แปลกหน้ามาพบที่ซ่อน คุณรอดมาได้อย่างหวุดหวิด", effects: { health: -20, safety: -10, cause: "predator" } },
        ],
      },
      {
        label: "คลานออกไปตามหาแม่",
        outcomes: [
          { chance: 0.5, text: "คุณเจอแม่ระหว่างทาง แม่คาบคุณกลับไปที่ซ่อน" },
          { chance: 0.35, text: "คุณหลงทางอยู่ครึ่งวันกว่าแม่จะตามเจอ", effects: { safety: -20, fullness: -10 } },
          { chance: 0.15, text: "นักล่าเจอคุณก่อนแม่", effects: { death: "predator" } },
        ],
      },
    ],
  },
  {
    id: "m_play",
    archetypes: ["MAMMAL"],
    stages: ["nursing", "juvenile"],
    weight: 4,
    text: "พี่น้องชวนคุณเล่นปล้ำกัน",
    choices: [
      { label: "เล่นด้วย", outcomes: [{ chance: 1, text: "คุณเรียนรู้วิธีต่อสู้และหลบหลีกไปในตัว", effects: { health: 5, safety: 10 } }] },
      { label: "นอนพักดีกว่า", outcomes: [{ chance: 1, text: "คุณประหยัดแรงไว้ได้", effects: { fullness: 5, health: 5 } }] },
    ],
  },
  {
    id: "m_weaning",
    opening: true,
    archetypes: ["MAMMAL"],
    stages: ["juvenile"],
    once: true,
    weight: 10,
    text: "แม่เริ่มไม่ให้นมแล้ว ถึงเวลาหัดหากินเอง",
    choices: [
      { label: "ตามแม่ไปเรียนรู้", outcomes: [{ chance: 1, text: "คุณจำได้ว่าอาหารอยู่ที่ไหนและอะไรกินได้", effects: { fullness: 15, safety: 10 } }] },
      {
        label: "ลองหาเองตามลำพัง",
        outcomes: [
          { chance: 0.5, text: "คุณพรสวรรค์สูง หาอาหารได้เองตั้งแต่ครั้งแรก", effects: { fullness: 25 } },
          { chance: 0.5, text: "คุณหลงทางและหิวโซ", effects: { fullness: -10, safety: -10 } },
        ],
      },
    ],
  },
  {
    id: "m_leave_home",
    archetypes: ["MAMMAL"],
    stages: ["juvenile"],
    once: true,
    weight: 4,
    text: "ถึงเวลาออกจากถิ่นเดิม ไปหาอาณาเขตของตัวเอง",
    choices: [
      {
        label: "ออกเดินทางไกล",
        outcomes: [
          { chance: 0.6, text: "คุณเจอถิ่นใหม่ที่อาหารอุดมสมบูรณ์", effects: { move: "far", fullness: 15, safety: 10 } },
          { chance: 0.4, text: "การเดินทางยาวไกลและอันตราย คุณมาถึงด้วยสภาพอิดโรย", effects: { move: "far", health: -15, fullness: -15, cause: "accident" } },
        ],
      },
      { label: "อยู่ใกล้ถิ่นเดิม", outcomes: [{ chance: 1, text: "คุณต้องแย่งอาหารกับตัวอื่นตลอด", effects: { safety: -10, fullness: -5 } }] },
    ],
  },
  {
    id: "m_territory",
    archetypes: ["MAMMAL"],
    stageTags: ["adult"],
    weight: 3,
    text: "มีตัวอื่นรุกล้ำเข้ามาในอาณาเขตของคุณ",
    choices: [
      {
        label: "ขับไล่มันออกไป",
        outcomes: [
          { chance: 0.6, text: "มันยอมถอยไป อาณาเขตยังเป็นของคุณ", effects: { safety: 10 } },
          { chance: 0.4, text: "การต่อสู้ดุเดือด คุณชนะแต่ได้แผลกลับมา", effects: { health: -20, addFlags: ["injured"], cause: "accident" } },
        ],
      },
      { label: "ยอมถอย", outcomes: [{ chance: 1, text: "คุณย้ายไปอยู่มุมที่อาหารน้อยกว่า", effects: { move: "near", safety: -10, fullness: -5 } }] },
    ],
  },
  {
    id: "m_hunt",
    archetypes: ["MAMMAL"],
    stages: ["juvenile", "adult", "elder"],
    requires: { diet: ["carnivore"] },
    weight: 7,
    text: "คุณเห็นเหยื่อตัวหนึ่งกำลังเผลอ",
    choices: [
      {
        label: "ซุ่มรอจังหวะ",
        outcomes: [
          { chance: 0.55, text: "จังหวะเดียวก็สำเร็จ คุณได้อาหารมื้อใหญ่", effects: { fullness: 40 } },
          { chance: 0.45, text: "มันไหวตัวทันและหนีไปได้", effects: { fullness: -5 } },
        ],
      },
      {
        label: "พุ่งเข้าใส่ทันที",
        outcomes: [
          { chance: 0.4, text: "ความเร็วของคุณชนะ!", effects: { fullness: 45 } },
          { chance: 0.4, text: "พลาดไปนิดเดียว", effects: { fullness: -10 } },
          { chance: 0.2, text: "เหยื่อสู้กลับจนคุณบาดเจ็บ", effects: { health: -15, cause: "accident" } },
        ],
      },
    ],
  },
  {
    id: "m_graze",
    archetypes: ["MAMMAL"],
    stages: ["juvenile", "adult", "elder"],
    requires: { diet: ["herbivore"] },
    weight: 7,
    text: "หลังฝนตก ทุ่งหญ้าเขียวขจีไปทั่ว",
    choices: [
      {
        label: "กินอยู่กลางทุ่ง",
        outcomes: [
          { chance: 0.75, text: "หญ้าอ่อนๆ อร่อยเหลือเกิน", effects: { fullness: 35 } },
          { chance: 0.25, text: "กลางทุ่งโล่งเกินไป นักล่าเริ่มย่องเข้ามา", effects: { fullness: 25, safety: -20 } },
        ],
      },
      { label: "กินแถวชายป่าที่ปลอดภัยกว่า", outcomes: [{ chance: 1, text: "อาหารน้อยกว่าแต่สบายใจกว่า", effects: { fullness: 20, safety: 5 } }] },
    ],
  },
  {
    id: "m_forage",
    archetypes: ["MAMMAL"],
    stages: ["juvenile", "adult", "elder"],
    requires: { diet: ["omnivore"] },
    weight: 7,
    text: "จมูกของคุณได้กลิ่นผลไม้สุกลอยมาตามลม",
    choices: [
      {
        label: "ตามกลิ่นไป",
        outcomes: [
          { chance: 0.7, text: "ต้นไม้ทั้งต้นออกผลเต็มไปหมด", effects: { fullness: 35 } },
          { chance: 0.3, text: "มีเจ้าถิ่นตัวใหญ่ยึดต้นนั้นอยู่ คุณต้องรีบหนี", effects: { fullness: 5, safety: -15 } },
        ],
      },
      { label: "ขุดหาอาหารแถวนี้", outcomes: [{ chance: 1, text: "คุณได้แมลงกับรากไม้มาพอประทังชีวิต", effects: { fullness: 20 } }] },
    ],
  },
  {
    id: "m_raise_young",
    archetypes: ["MAMMAL"],
    stageTags: ["adult"],
    requires: { flags: ["parent"] },
    weight: 6,
    text: "ลูกๆ ของคุณหิวตลอดเวลา",
    choices: [
      { label: "ทุ่มเทเลี้ยงลูกเต็มที่", outcomes: [{ chance: 1, text: "ลูกๆ โตขึ้นทุกวันจนแยกไปใช้ชีวิตเองได้", effects: { fullness: -20, removeFlags: ["parent"] } }] },
      { label: "ให้ลูกหัดหากินเองเร็วๆ", outcomes: [{ chance: 1, text: "ลูกๆ แยกไปเร็วกว่าที่ควร แต่คุณมีแรงเหลือ", effects: { fullness: 5, removeFlags: ["parent"] } }] },
    ],
  },
  {
    id: "m_bat_dusk",
    archetypes: ["MAMMAL"],
    stages: ["juvenile", "adult", "elder"],
    requires: { subgroups: ["mammal.bat"] },
    weight: 8,
    text: "พลบค่ำแล้ว แมลงบินว่อนเต็มท้องฟ้า",
    choices: [
      {
        label: "บินออกล่าทันที",
        outcomes: [
          { chance: 0.85, text: "เสียงสะท้อนบอกตำแหน่งแมลงทุกตัว คุณกินจนอิ่ม", effects: { fullness: 35 } },
          { chance: 0.15, text: "นกเค้าแมวตัวหนึ่งไล่ตามคุณ", effects: { fullness: 20, safety: -20 } },
        ],
      },
      { label: "รอให้มืดสนิทก่อน", outcomes: [{ chance: 1, text: "ความมืดช่วยพรางตัว แต่แมลงก็เหลือน้อยลง", effects: { fullness: 20, safety: 5 } }] },
    ],
  },
  {
    id: "m_whale_song",
    archetypes: ["MAMMAL"],
    stageTags: ["adult"],
    requires: { subgroups: ["mammal.whale"], notFlags: ["has_mate"] },
    weight: 5,
    text: "คุณได้ยินเสียงเพลงของวาฬตัวอื่นแว่วมาจากที่ไกล",
    choices: [
      {
        label: "ว่ายตามเสียงไป",
        outcomes: [
          { chance: 0.5, text: "เสียงนั้นนำคุณไปพบคู่", effects: { addFlags: ["has_mate"], fullness: -10 } },
          { chance: 0.5, text: "คุณว่ายไปไกลแต่ไม่พบใคร", effects: { move: "near", fullness: -15 } },
        ],
      },
      { label: "ร้องเพลงตอบ", outcomes: [{ chance: 1, text: "เสียงของคุณดังไปไกลหลายสิบกิโลเมตร", effects: { safety: 5 } }] },
    ],
  },
];
